import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import { loadStripe } from '@stripe/stripe-js';
import { observer } from 'mobx-react';
import {
  Elements,
  useStripe,
  useElements,
  CardCvcElement,
} from '@stripe/react-stripe-js';
import { STRIPE_KEY } from 'Utils/constants';

const stripePromise = loadStripe(STRIPE_KEY);

const StripeCVCForm = withRouter(
  observer(props => {
    const {
      clientSecret,
      paymentMethodId,
      btnText = '',
      callback,
      isHtmlBtnContent = false,
      HtmlBtnContent,
    } = props;
    const stripe = useStripe();
    const elements = useElements();

    const [cardErr, setCardErr] = useState('');
    const [btnLoader, setBtnLoader] = useState(false);

    const formSubmit = async event => {
      if (event) event.preventDefault();
      if (stripe) {
        setBtnLoader(true);
        const cardCvcElement = elements.getElement(CardCvcElement);

        const { error, paymentIntent } = await stripe.confirmCardPayment(
          clientSecret,
          {
            payment_method: paymentMethodId,
            payment_method_options: {
              card: {
                cvc: cardCvcElement,
              },
            },
          },
        );
        if (error) {
          const {
            code: failedCode = '',
            decline_code: declineCode = '',
            message,
          } = error;

          if (
            failedCode === 'incorrect_cvc' ||
            failedCode === 'incomplete_cvc'
          ) {
            setCardErr(message);
            setBtnLoader(false);
          } else {
            callback(null, { failedCode, declineCode });
          }
        } else if (
          paymentIntent &&
          paymentIntent.status === 'requires_capture'
        ) {
          callback(paymentIntent);
        }
      }
    };

    return (
      <form
        onSubmit={formSubmit}
        autoComplete="off"
        name="cvcCheckForm"
        className="cvcCheckForm"
        noValidate
      >
        <div className="cardInput">
          <CardCvcElement />
        </div>
        <div className="errMsgText">{cardErr}</div>

        <div className="submitSection">
          <button
            type="submit"
            disabled={!stripe}
            className={`animatedButton ${btnLoader ? 'loading' : ''}`}
          >
            {!btnLoader && !isHtmlBtnContent && <span>{btnText}</span>}
            {!btnLoader && isHtmlBtnContent && <HtmlBtnContent />}
            {btnLoader && <span className="load-text" />}
          </button>
        </div>
      </form>
    );
  }),
);

const StripeCVVCheck = props => {
  return (
    <Elements stripe={stripePromise}>
      <StripeCVCForm {...props} />
    </Elements>
  );
};

export default withRouter(observer(StripeCVVCheck));
